import React, { useContext, useState, useEffect } from "react";

import { RepeatOrderContext } from "../../providers/RepeatOrderProvider";
import Tooltip from "../tooltip/Tooltip";
import Button from "../button/Button";
import "./bookConsultantCard.scss";

function BookConsultantCard({ onBookConsultant }) {
    const { isRepeatOrder, hasSixMonthsPassed, canOrder, nextConsultationDate } = useContext(RepeatOrderContext);
    const [repeatConsultation, setRepeatConsultation] = useState(true);

    // Block repeat consultaion, if the last consultation is below 6 months
    useEffect(() => {
        if (isRepeatOrder && !hasSixMonthsPassed) {
            setRepeatConsultation(false);
        }
        else {
            setRepeatConsultation(true);
        }
    }, [isRepeatOrder, hasSixMonthsPassed]);

    const tooltipText = !canOrder ? "There is already an active order in progress" : "";

    return (
        <div
            className={`bg-white d-flex flex-column flex-lg-row justify-content-between align-items-sm-center rounded p-3 p-sm-4 gap-sm-3 gap-2`}
        >
            <div className="d-flex align-items-sm-center">
                <img
                    src="/images/vectors/stethoscope.svg"
                    className="img-fluid d-none d-sm-block"
                    alt="doctor"
                />
                <div className="ms-0 ms-sm-4">
                    <div className={`primary-title text-primary fw-bold fs-5`}>
                        {
                            (isRepeatOrder & hasSixMonthsPassed) ? `6 Month Review Due By : ${nextConsultationDate}`
                                : (isRepeatOrder & !hasSixMonthsPassed) ? `Next 6 Month Review Consultation Due : ${nextConsultationDate}`
                                    : "Book a Consultation"
                        }
                    </div>
                    <div className={`secondary-title text-dark-5 fw-light`}>
                        {isRepeatOrder
                            ? (hasSixMonthsPassed
                                ? "You are now due for a video consultation with a clinician to review your medication. This appointment must be completed first so that you can proceed with your next order without delay."
                                : "You are not due a video consultation yet, so please proceed with a repeat order as above. If you require a video consultation with a clinician sooner, please get in touch with us."
                            )
                            : "Consult with an expert regarding your condition"}
                        {isRepeatOrder && (
                            <div className="mt-2">
                                {hasSixMonthsPassed
                                ? "If you need any help with booking this consultation, you can contact us via email at "
                                : "You can contact us via email at "
                                }
                                <a href="mailto:support@treat-it.clinic" className="text-primary fw-bold"> support@treat-it.clinic</a>
                                <span className="secondary-title text-dark-5 fw-light"> or via{" "}
                                    <a
                                        href="https://wa.me/447385828801"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="fw-bold text-decoration-none"
                                    >WhatsApp</a>
                                    , and we'll be happy to arrange it for you.
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="button-container">
                <Tooltip
                    message={tooltipText}
                    position="bottom"
                    hidden={canOrder}
                >
                    <Button
                        variant="primary btn-sm book-appointment-btn fw-bold py-2 px-4 text-nowrap mt-2"
                        onClick={onBookConsultant}
                        disabled={!repeatConsultation || !canOrder}
                    >
                        <img
                            src="/images/vectors/video.svg"
                            alt="video"
                            className="me-2"
                        />
                        Book a Review Consultation
                    </Button>
                </Tooltip>
                {<a
                    href="https://wa.me/447385828801"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex align-items-center justify-content-center gap-2 flow-gap py-2 px-3 w-100 w-md-fit h-fit fw-bold text-decoration-none border rounded bg-transparent text-nowrap
                    text-primary-600 border-primary-600 mt-2"
                >
                    <img
                        src="/images/vectors/whatsapp.svg"
                        alt="completed"
                        className="google-icon"
                    />
                    Message us on WhatsApp
                </a>}
            </div>
        </div>
    );
}

export default BookConsultantCard;
